import { ViewConfig } from '@spartacus/storefront';

export const PAGE_SIZE_OPTIONS = {
  default: 30,
  increased: 90,
};

export const rrsViewConfig: ViewConfig = {
  view: { defaultPageSize: PAGE_SIZE_OPTIONS.default },
};
